<template>
  <div class="form-group" :class="classFormGroup">
    <label v-if="label">{{ label }}
      <span v-if="required" style="color: red;"> *</span>
      <span v-if="conditionalRequired" style="color: blue;"> *</span>
      <br>
      <span v-if="validation?.$error" style="color: red;">{{ messages }}</span>
    </label>
    <VueSelect
        :is-disabled="false" class="w-0"
        v-model="internalValue"
        :is-multi="isMulti"
        :options="options"
        :is-clearable="isClear"
        :style="inputStyle"
        :placeholder="placeholder" autocomplete="off"
        :isDisabled="isDisabled"
        menu-placement="positionType"
        :class="{ 'is-invalid': validation?.$error, 'disabled': isDisabled , 'isMulti': isMulti }"
        @search="onSearch">

      <template #no-options>
        <div v-if="showMinCharsMessage" style="padding: 5px 12px; color: #888; text-align: center;">
          Um Ergebnisse anzuzeigen, geben Sie bitte mindestens 3 Zeichen ein
        </div>
        <div v-else style="padding: 5px 12px; color: #888; text-align: center;">
          Kein Ergebnis
        </div>
      </template>
    </VueSelect>
  </div>
</template>

<script setup>
import {computed, defineEmits, defineProps, ref, watch} from 'vue';
import VueSelect from 'vue3-select-component';
import "vue3-select-component/styles";

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  modelValue: {
    type: [Number, String, Array, Object, null],
    default: null,
  },
  isMulti: {
    type: Boolean,
    default: false,
  },
  classFormGroup: {
    type: String,
    default: '',
  },
  positionType: {
    type: String,
    default: 'bottom',
  },
  isClear: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: [String, Boolean],
    default: '',
  },
  inputStyle: {
    type: Object,
    default: () => ({}),
  },
  label: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  conditionalRequired: {
    type: Boolean,
    default: false,
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
  messages: {
    type: String,
    default: '',
  },
  showMinCharsMessage: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue', 'dropdown-fetch']);

const internalValue = ref(props.modelValue);
const isDisabled = computed(() => props.disabled);

watch(internalValue, (newValue) => {
  if (!props.disabled) {
    emit('update:modelValue', newValue);
  } else {
    internalValue.value = props.modelValue;
  }
});

watch(() => props.modelValue, (newValue) => {
  internalValue.value = newValue;
});

const onSearch = (search) => {
  emit('dropdown-fetch', search)
}

</script>

<style scoped>
/* Font size */
:deep(.vue-select .value-container) {
  font-size: 14px;
}

:deep(.vue-select .dropdown-option) {
  font-size: 14px;
}

:deep(.vue-select .placeholder) {
  font-size: 13px;
}

:deep(.multi-value-label) {
  font-size: 16px;
}

:deep(.vue-select .control) {
  border: 2px solid #dde2ec;
  min-height: calc(calc(1.5em + 0.75rem) + 4px);
}

:deep(.vue-select .value-container.multi) {
  padding: 2px;
}

:deep(.vue-select .control.focused) {
  border-color: var(--primary);
  box-shadow: none;
}

:deep(.vue-select .menu) {
  max-height: 400px;
  z-index: 1000;
}

/* Before update */
:deep(.vue-select .search-input) {
  //position: absolute;
  //cursor: pointer!important;
  //height: 100%;
  //width: 100%;
}

/* After update */
:deep(.vue-select .input-container) {
  cursor: pointer !important;
  height: 100%;
  width: 100%;
}

:deep(.vue-select.isMulti .input-container) {
  position: unset !important;
  height: unset !important;
  border: 1px solid #e5e7eb;
  border-radius: 2px;
  width: 100%;
}

:deep(.vue-select.isMulti .input-placeholder) {
  padding: 5px !important;
}

:deep(.vue-select .search-input:disabled) {
  background-color: #f0f0f0;
  border-color: #ccc;
  pointer-events: none;
}

:deep(.vue-select .multi-value) {
  z-index: 10;
}

:deep(.vue-select .selected) {
  background-color: var(--primary);
  color: white;
}

:deep(.menu-option.focused) {
  background-color: #d3f0d6;
}

:deep(.menu-option:hover) {
  background-color: color-mix(in srgb, var(--primary) 70%, white);
}

:deep(.vue-select[data-position="top"] .menu) {
  bottom: 100%;
  top: auto;
}

:deep(.vue-select.disabled input) {
  background-color: #e9ecef;
  opacity: 0.5;
}

:deep(.vue-select.disabled .menu-option) {
  background-color: #e9ecef;
  opacity: 1;
}

</style>